import type { ScreenItem } from 'shared/src/types';
import { WEB_ROUTE_PATHS } from 'shared/src/webRoutePaths';
import { HomeScreen } from './screens/Home/Home.screen';
import { CategoryScreen } from './screens/Category';
import { TodayShippingScreen } from './screens/TodayShipping';
import { ContentsScreen } from './screens/Contents';
import { LikeScreen } from './screens/Like';
import { FolderDetailScreen } from './screens/FolderDetail';
import { LikeMarketListScreen } from './screens/LikeMarketList';
import { EditGoodsLikeScreen } from './screens/EditGoodsLike';
import { MyPageScreen } from './screens/MyPage';
import { GoodsRankingScreen } from './screens/Home/GoodsRanking.screen';
import { MarketRankingScreen } from './screens/Home/MarketRanking.screen';
import { FragmentTodayScreen } from './screens/Home/Today.screen';
import { ServiceMapScreen } from './screens/ServiceMap';

export type HomeStackParamList = {
  Home: {
    selected?: string;
    market_type_sno?: string;
  };
  EditGoodsLike: {
    instanceId?: string;
    categorySno?: number | null;
    isDeliveryFilterOn?: boolean;
    order?: string | null;
  };
};

export const HomeScreens: ScreenItem[] = [
  // {
  //   name: 'Home',
  //   component: HomeScreen,
  //   path: '/',
  //   options: {
  //     tabBarLabel: '홈',
  //   },
  // },
  // {
  //   name: 'Category',
  //   component: CategoryScreen,
  //   path: '/category',
  //   options: {
  //     tabBarLabel: '카테고리',
  //   },
  // },
  {
    name: 'EditGoodsLike',
    component: EditGoodsLikeScreen,
    path: WEB_ROUTE_PATHS.EditGoodsLike,
    options: {
      title: '전체 상품 - 에이블리 스토어',
    },
    convertParams: props => {
      const extras =
        typeof props.extras === 'string'
          ? (() => {
              try {
                return JSON.parse(props.extras as string);
              } catch {
                return {};
              }
            })()
          : (props.extras ?? {});

      return {
        categorySno:
          typeof extras.category_sno === 'string'
            ? Number(extras.category_sno)
            : (extras.category_sno ?? null),
        isDeliveryFilterOn:
          typeof extras.is_fast_delivery === 'string'
            ? extras.is_fast_delivery === 'true'
            : Boolean(extras.is_fast_delivery),
        order: extras.order ?? null,
      };
    },
  },
  {
    name: 'LikeMarketList',
    component: LikeMarketListScreen,
    path: '/like-markets',
  },
  {
    name: 'FolderDetail',
    component: FolderDetailScreen,
    path: WEB_ROUTE_PATHS.FolderDetail,
    convertParams: props => {
      const target = Array.isArray(props.extras)
        ? props.extras[0]
        : props.extras;
      const extras =
        typeof target === 'string'
          ? (() => {
              try {
                return JSON.parse(target);
              } catch {
                return {};
              }
            })()
          : (target ?? {});
      return {
        folderSno: Number(
          extras.sno ?? extras.folderSno ?? props.params ?? 0,
        ),
      };
    },
  },
  {
    name: 'GoodsRanking',
    component: GoodsRankingScreen,
    path: '/goods-ranking',
  },
  {
    name: 'MarketRanking',
    component: MarketRankingScreen,
    path: '/market-ranking',
  },
  {
    name: 'LikeFragment',
    component: LikeScreen,
    path: '/like-fragment',
  },
  {
    name: 'FragmentsOverView',
    component: CategoryScreen,
    path: '/fragments/overview',
  },
  {
    name: 'FragmentsLike',
    component: LikeScreen,
    path: '/fragments/like',
  },
  {
    name: 'FragmentToday',
    component: FragmentTodayScreen,
    path: '/fragments/today',
  },
  {
    name: 'ServiceMap',
    component: ServiceMapScreen,
    path: WEB_ROUTE_PATHS.ServiceMap,
    options: {
      title: '전체메뉴',
    },
  },
];
export const HomeTabScreens: ScreenItem[] = [
  {
    name: 'Home',
    component: HomeScreen,
    path: '/:selected?',
    options: {
      tabBarLabel: '홈',
    },
  },
  {
    name: 'Overview',
    component: CategoryScreen,
    path: '/overview',
    options: {
      tabBarLabel: '카테고리',
    },
  },
  {
    name: 'TodayShipping',
    component: TodayShippingScreen,
    path: '/today-shipping',
    options: {
      tabBarLabel: '오늘출발',
    },
  },
  {
    name: 'Contents',
    component: ContentsScreen,
    path: '/contents',
    options: {
      tabBarLabel: '콘텐츠',
    },
  },
  {
    name: 'Like',
    component: LikeScreen,
    path: '/like',
    options: {
      tabBarLabel: '찜',
    },
  },
  {
    name: 'MyPage',
    component: MyPageScreen,
    path: '/mypage',
    options: {
      tabBarLabel: '마이페이지',
    },
  },
];
